import { Typography } from '@sravni/react-design-system';
import React from 'react';

import { LottieLoader } from 'shared/ui/lottie.loader';

import { LOOKING_BEST_BANKS_TEXT } from 'features/SlidesLoader/config';

import animationData from '../../config/animations/banks.json';

import styles from './styles.module.scss';

export const BanksLoad: React.FC = () => {
  return (
    <div className={styles.wrapper}>
      <LottieLoader
        className={styles.imageContainer}
        options={{ animationData }}
        height={170}
      />
      <Typography.Heading
        className={styles.heading}
        level={4}
      >
        {LOOKING_BEST_BANKS_TEXT}
      </Typography.Heading>
    </div>
  );
};
